module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[45]288.acfc603.woff2";